import { render } from "./ImageCompressionModal.vue?vue&type=template&id=8cc02a82&scoped=true"
import script from "./ImageCompressionModal.vue?vue&type=script&lang=ts"
export * from "./ImageCompressionModal.vue?vue&type=script&lang=ts"

import "./ImageCompressionModal.vue?vue&type=style&index=0&id=8cc02a82&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8cc02a82"

export default script